/**
 * Company onboarding completion — 5 sections × 20% each (per CS Admin spec).
 * Uses counts/fields already returned on the companies list API.
 */
export function computeCompanySetupProgress(company = {}) {
  if (!company) return 0;

  let score = 0;

  const hasBasicInfo = Boolean(
    company.name
    && (company.tradeLicenseNumber || company.registration_number)
    && company.country
  );
  if (hasBasicInfo) score += 20;

  if ((Number(company.director_count ?? company.directorCount) || 0) > 0) score += 20;
  if ((Number(company.document_count ?? company.documentCount) || 0) > 0) score += 20;
  if ((Number(company.officer_count ?? company.officerCount) || 0) > 0) score += 20;
  if ((Number(company.committee_count ?? company.committeeCount) || 0) > 0) score += 20;

  return score;
}

export function setupProgressLabel(progress) {
  const value = Number(progress) || 0;
  if (value >= 100) return 'Complete';
  if (value === 0) return 'Not started';
  return 'In progress';
}
